import { createFileRoute } from "@tanstack/react-router";
import { CABINET_HOME_COPY } from "@/components/partners/cabinet-home-copy";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";
import { TutorCabinetEditPage } from "@/components/partners/TutorCabinetPage";

// «Изменить анкету» (en) — отдельный экран кабинета. «_» после me — не вкладывать
// в главную кабинета: у неё нет <Outlet/>. noindex, в sitemap нет.
export const Route = createFileRoute("/en/tutors/me_/edit")({
  head: () => tutorCabinetHead("en", CABINET_HOME_COPY.en.editTitle),
  component: () => <TutorCabinetEditPage lang="en" />,
});
